import { QueovalBase } from '../global';

export class MapModel extends QueovalBase {
  public lat: number;
  public lng: number;
  public viewport: Object;
  public zoom: number;
  public address: string;
  public address_state: string;
  public marker: Marker;
}

export class Marker {
  public lat: number;
  public lng: number;
  public label: string;
  public draggable: boolean;
}
